import type { ApiClient } from './ApiClient';

// Formes alignées sur POST /devices, DELETE /devices/:id (MOB-06,
// apps/api/src/routes/devices.ts).
export type DevicePlatform = 'IOS' | 'ANDROID';

export interface RegisteredDevice {
  id: string;
  platform: DevicePlatform;
  createdAt: string;
}

export interface RegisterDevicePayload {
  token: string;
  platform: DevicePlatform;
}

export function registerDevice(client: ApiClient, payload: RegisterDevicePayload, accessToken: string): Promise<RegisteredDevice> {
  return client.post<RegisteredDevice>('/devices', payload, { accessToken });
}

export function unregisterDevice(client: ApiClient, deviceId: string, accessToken: string): Promise<void> {
  return client.delete<void>(`/devices/${deviceId}`, { accessToken });
}
